import React from 'react';
import { Zap, Shield, BarChart, LifeBuoy, Workflow, Trash2, Eye, Power, Cpu } from 'lucide-react';
import { motion } from 'framer-motion';

const featuresList = [
  {
    icon: <Zap size={24} className="text-primary-400" />,
    title: 'Lightning Fast Optimization',
    description: 'Boost your PC performance with our proprietary optimization algorithms that target system bottlenecks.'
  },
  {
    icon: <Shield size={24} className="text-primary-400" />,
    title: 'System Protection',
    description: 'Protect your PC from crashes and data loss with our intelligent system monitoring.'
  },
  {
    icon: <Trash2 size={24} className="text-primary-400" />,
    title: 'Advanced System Cleaner',
    description: 'Deep clean your system of temporary files, cache, and other unnecessary data that slows down your PC.'
  },
  {
    icon: <Eye size={24} className="text-primary-400" />,
    title: 'Visual Effects Optimizer',
    description: 'Optimize Windows visual effects for the perfect balance between aesthetics and performance.'
  },
  {
    icon: <Power size={24} className="text-primary-400" />,
    title: 'Service Manager',
    description: 'Intelligently manage and optimize Windows services for improved system performance.'
  },
  {
    icon: <Cpu size={24} className="text-primary-400" />,
    title: 'Telemetry Control',
    description: 'Take control of Windows telemetry and background processes to enhance privacy and performance.'
  },
  {
    icon: <BarChart size={24} className="text-primary-400" />,
    title: 'Performance Analytics',
    description: 'Get detailed insights into your system performance with our comprehensive analytics dashboard.'
  },
  {
    icon: <LifeBuoy size={24} className="text-primary-400" />,
    title: '24/7 Support',
    description: 'Our expert team is always available to help you with any issues or questions you may have.'
  },
  {
    icon: <Workflow size={24} className="text-primary-400" />,
    title: 'Smart Process Management',
    description: 'Automatically optimize background processes to free up system resources for what matters.'
  }
];

const Features: React.FC = () => {
  return (
    <section id="features" className="py-20 bg-dark-800">
      <div className="container px-4 mx-auto">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-3xl font-bold text-white md:text-4xl">Powerful Features</h2>
          <p className="mx-auto max-w-3xl text-xl text-dark-300">
            Discover why thousands of users trust WinMax Optimizer to keep their PCs running at peak performance.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {featuresList.map((feature, index) => (
            <motion.div
              key={index}
              className="p-8 rounded-lg border shadow-xl transition-shadow bg-dark-900 hover:shadow-2xl border-dark-700"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="inline-block p-3 mb-5 rounded-lg bg-dark-800">
                {feature.icon}
              </div>
              <h3 className="mb-3 text-xl font-semibold text-white">{feature.title}</h3>
              <p className="text-dark-400">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;